import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContractorForm from '../contractors/ContractorForm';
import { getCurrentUser } from '../../../selectors/authentication';
import {
  loadContractorRequest,
  loadNewContractorParametersRequest,
  selectServiceArea,
  selectTrade,
  selectUnion,
  setW9Document,
  submitFormRequest,
  updateFormFromCurrentContractor,
  updateFormValue,
  hideMsaSigningModal,
} from '../../../actions/admin/contractors/contractors';
import {
  getCurrentContractor,
  getForm,
  getInvalidFields,
  getSelectedServiceAreasId,
  getSelectedTradesId,
  getSelectedUnionsId,
  getW9Document,
  getServiceAreas,
  getTrades,
  getUnions,
  getValidationMessage,
  getMsaSigningUrl,
  getShowMsaSigningModal,
} from '../../../selectors/admin/contractors/contractors';
import { goToTeam } from 'actions/admin/team/contractor-team';
import { TYPES } from 'services/utils/users-util';
import SigningModal from 'components/shared/modal/SigningModal';

class ContractorTeamEdit extends Component {
  constructor(props) {
    super(props);
    this.contractorId = this.props.currentUser.accountable_id;
  }

  componentDidMount() {
    this.props
      .dispatch(
        loadNewContractorParametersRequest(
          this.props.serviceAreas,
          this.props.trades,
          this.props.unions
        )
      )
      .then(() => {
        if (this.props.contractor === null) {
          // If contractor not loaded, load it
          this.props
            .dispatch(loadContractorRequest(this.contractorId))
            .then(() =>
              this.props.dispatch(
                updateFormFromCurrentContractor(this.props.contractor)
              )
            )
            .then(() => this.setConfirmed());
        } else {
          this.props.dispatch(
            updateFormFromCurrentContractor(this.props.contractor)
          );
          this.setConfirmed();
        }
      });
  }

  setConfirmed = () => {
    if (this.props.currentUser.accountable_type === TYPES.CONTRACTOR) {
      this.handleFormChange('confirmed', true);
    }
  };

  needsConfirmation = () => {
    return (
      this.props.currentUser.accountable_type === TYPES.CONTRACTOR &&
      !this.props.contractor.confirmed
    );
  };

  handleServiceAreaSelection = (value) => {
    this.props.dispatch(selectServiceArea(value));
  };

  handleTradesSelection = (value) => {
    this.props.dispatch(selectTrade(value));
  };

  handleUnionSelection = (value) => {
    this.props.dispatch(
      selectUnion(value, this.props.unions, this.props.selectedUnionsId)
    );
  };

  handleW9DocumentChange = (file) => {
    this.props.dispatch(setW9Document(file));
  };

  handleFormChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleSubmit = () => {
    this.props.dispatch(
      submitFormRequest(
        this.props.form,
        this.props.selectedServiceAreasId,
        this.props.selectedTradesId,
        this.props.selectedUnionsId,
        this.props.w9Document,
        false,
        this.contractorId,
        this.needsConfirmation()
      )
    );
  };

  handleMsaSigningModalClose = () => {
    this.props.dispatch(goToTeam());
    this.props.dispatch(hideMsaSigningModal());
  };

  render() {
    return (
      this.props.contractor && (
        <div>
          <ContractorForm
            edit={true}
            needsConfirmation={this.needsConfirmation()}
            form={this.props.form}
            invalidFields={this.props.invalidFields}
            selectedServiceAreasId={this.props.selectedServiceAreasId}
            selectedTradesId={this.props.selectedTradesId}
            selectedUnionsId={this.props.selectedUnionsId}
            w9Document={this.props.w9Document}
            serviceAreas={this.props.serviceAreas}
            trades={this.props.trades}
            unions={this.props.unions}
            validationMessage={this.props.validationMessage}
            withInvitation={false}
            onFormChange={this.handleFormChange}
            onServiceAreaSelection={this.handleServiceAreaSelection}
            onSubmit={this.handleSubmit}
            onTradesSelection={this.handleTradesSelection}
            onUnionSelection={this.handleUnionSelection}
            onW9DocumentChange={this.handleW9DocumentChange}
          />

          <SigningModal
            show={this.props.showMsaSigningModal}
            url={this.props.msaSigningUrl}
            title="Sign MSA"
            handleClose={this.handleMsaSigningModalClose}
          />
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    contractor: getCurrentContractor(state),
    currentUser: getCurrentUser(state),
    invalidFields: getInvalidFields(state),
    form: getForm(state),
    serviceAreas: getServiceAreas(state),
    selectedServiceAreasId: getSelectedServiceAreasId(state),
    selectedTradesId: getSelectedTradesId(state),
    selectedUnionsId: getSelectedUnionsId(state),
    w9Document: getW9Document(state),
    trades: getTrades(state),
    unions: getUnions(state),
    validationMessage: getValidationMessage(state),
    msaSigningUrl: getMsaSigningUrl(state),
    showMsaSigningModal: getShowMsaSigningModal(state),
  };
})(ContractorTeamEdit);



// WEBPACK FOOTER //
// ./src/components/admin/team/ContractorTeamEdit.js